// Invoices store `jobId` as a loose string, not a Prisma relation. It may be
// empty (a standalone invoice) or the 'QB-IMPORT' sentinel that QuickBooks sync
// writes when there is no real job behind the imported invoice.
export const QB_IMPORT_SENTINEL = 'QB-IMPORT';

/**
 * The real job id an invoice links to, or `undefined` when there is none — a
 * standalone invoice (empty jobId) or a QuickBooks-imported one (the sentinel).
 * Use this to gate any job fetch so the sentinel is never queried as a real job.
 */
export function invoiceLinkedJobId(jobId?: string | null): string | undefined {
  return jobId && jobId !== QB_IMPORT_SENTINEL ? jobId : undefined;
}
